module.exports = __webpack_public_path__ + "static/studio-a-console-2-5f15a195d878f6e30ed60bbd21b8ec23.jpg";